import type { User } from "firebase/auth";
import { loadGameArtForUser } from "@/shadow/merge-game-art";
import { loadCharacterProfile } from "@/character/storage";
import { mountDomHud } from "@/game/ui/dom-hud";
import { startGame } from "@/game/main";

export function mountGameShell(root: HTMLElement, user: User): () => void {
  root.className = "game-app";
  root.innerHTML = `
    <div id="game-shell">
      <header class="game-topbar">
        <a class="text-link" href="/">← หน้าแรก</a>
      </header>
      <div id="game-container"></div>
      <aside id="hud" aria-live="polite"></aside>
    </div>
  `;

  const container = root.querySelector<HTMLElement>("#game-container");
  if (!container) {
    throw new Error("Missing #game-container");
  }

  const profile = loadCharacterProfile(user.uid);
  mountDomHud();
  let game = startGame(container, undefined);
  if (profile) {
    void loadGameArtForUser(user.uid, profile).then((art) => {
      game.destroy(true);
      game = startGame(container, art);
    });
  }

  return () => {
    game.destroy(true);
  };
}
